import setLoading from "actions/loading";

export const errorMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    const done = action.type.endsWith("_REJECTED") || action.type.endsWith("_FULFILLED");
    const busy = action.type.endsWith("_PENDING");

    if (done || busy) {
      const entity = action.type.split("_")[0].toLowerCase();

      dispatch(setLoading(entity, busy));
    }

    return next(action);
  };

export default errorMiddleware;
